export const randomSoundNumber = (numberQuestion, verity) => {
  const number = Math.floor(Math.random() * 4) + 1

  if (numberQuestion === 1 && number === 4 && verity === true) {
    return 3
  }

  return number
}
